// extracted by mini-css-extract-plugin
export default {"root":"QuizProgressBar_root-CbY","line":"QuizProgressBar_line-wMA","lineActive":"QuizProgressBar_lineActive-S_Z"};